var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list_menu"},_vm._l((_vm.list_info),function(o,i){return _c('router-link',{key:i,staticClass:"menu_item",class:{ selected: o.selected },attrs:{"to":o.url}},[_c('span',{staticClass:"left_span"},[_vm._v(_vm._s(o.title))]),_c('span',{staticClass:"right_span"},[_c('b-icon',{attrs:{"icon":o.icon}})],1)])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }